"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const cmp_client_1 = require("@financial-times/cmp-client");
const localhosts = ['localhost', '0.0.0.0', '127.0.0.1'];
let spProps, property;
const hostNameParts = window.location.hostname.split('.');
const apexDomainPartsCount = hostNameParts.slice(-1)[0] === 'uk' ? 3 : 2;
const apexDomain = hostNameParts.slice(-apexDomainPartsCount).join('.');
const geoConfig = {
    usnat: {
        text: 'Do Not Sell My Personal Information',
        // @ts-ignore
        action: () => window._sp_.usnat.loadPrivacyManagerModal(1331838)
    },
    gdpr: {
        text: 'Manage Cookies',
        // @ts-ignore
        action: () => window._sp_.gdpr.loadPrivacyManagerModal(941275)
    }
};
if (localhosts.includes(window.location.hostname)) {
    spProps = {
        useConsentStore: false,
        cookieDomain: window.location.hostname,
        useFTSession: false
    };
    property = cmp_client_1.properties.FT_DOTCOM_TEST;
}
else {
    property = Object.entries(cmp_client_1.properties)
        .find(([, property]) => property.baseEndpoint.endsWith(apexDomain))?.[1];
    if (!property) {
        console.error('Property ID not configured for: ', apexDomain);
    }
    spProps = {
        useConsentStore: false,
        cookieDomain: `.${apexDomain}`,
        consentProxyHost: `https://consent.${apexDomain}`,
        useFTSession: false,
        ...(property?._clientOptions || {})
    };
}
// adapt info from the custom oTracking.event dispatched by the cmp-client package
// and push it to Snowplow
window.addEventListener("oTracking.event", (e) => {
    if (e?.detail?.component?.subtype === 'cmp') {
        window.dataLayer = window.dataLayer || [];
        //flush entities from previous event
        window.dataLayer.push({ 'event': 'flushEntities', 'event_payload': undefined });
        const cmpBanner = {
            category: 'CMP Banner',
            banner_name: e?.detail?.component?.name,
            action: e?.detail?.action.charAt(0)?.toUpperCase() + e?.detail?.action?.slice(1),
            banner_id: e?.detail?.component?.id?.toString(),
            click_action: e?.detail?.trigger_action
        };
        window.dataLayer.push({
            event: 'analytics_event',
            event_payload: {
                schema: 'iglu:com.financialtimes/cmp_banner/jsonschema/1-0-0',
                data: cmpBanner
            }
        });
    }
}, false);
// a wrapper for the code that would execute for the Manage Cookies link in the footers
window._specialist_manage_cookies = () => {
    // @ts-ignore
    window._sp_.gdpr.loadPrivacyManagerModal(941275);
};
function updateManageCookiesLink(message_type) {
    const defaultLinkText = geoConfig.gdpr.text;
    const link = [...document.querySelectorAll('footer a')]
        .find(a => a.textContent.trim().toLowerCase() === defaultLinkText.toLowerCase());
    if (link) {
        const config = geoConfig[message_type] || geoConfig.gdpr;
        link.textContent = config.text;
        link.setAttribute('href', '#');
        link.setAttribute('role', 'button');
        link.addEventListener('click', event => {
            event.preventDefault();
            config.action();
        });
    }
}
const onConsentReadyHandler = function (message_type, _uuid, _string, consentMeta) {
    return new Promise((resolve) => {
        // Type assertion to ensure message_type is one of the valid keys
        const typedMessageType = message_type;
        // need this log to verify the handler is called - to be removed later
        console.log("CMP onConsentReady event", { message_type: typedMessageType, consentMeta });
        updateManageCookiesLink(typedMessageType);
        if (consentMeta.applies) {
            window._sp_queue.push(() => {
                // @ts-ignore
                window._sp_.removeEventListener?.("onConsentReady", onConsentReadyHandler);
            });
        }
        resolve();
    });
};
window._sp_queue ??= [];
window._sp_queue.push(() => {
    window._sp_.addEventListener?.("onConsentReady", onConsentReadyHandler);
});
(0, cmp_client_1.initSourcepointCmp)({
    propertyConfig: property,
    ...spProps
});
